module.exports = __webpack_public_path__ + "d8008334e72b6f716fb7ef371c3a6d8c.svg";